import React from "react";
import MainNavigation from "../../components/NavBar/MainNavigation";
import FooterComponent from "../../components/Footer/FooterComponent";

import ContactUs from "./composant/ContactUs";

const ContactPage = () => {
  return (
    <div className="flex flex-col gap-4 min-h-screen">
      <MainNavigation />
      <div
        className="h-48 mt-12 flex justify-center items-center"
        /*  style={{ backgroundImage: `url(${ImageInfo})` }} */
        style={{
          background:
            "linear-gradient(135deg, rgb(36, 145, 58) 0%, #1ec540 50%, #56ab2f 100%)",
          /*  textAlign: "center",  */
          borderRadius: "10px",
        }}
      >
        <section className="text-center">
          <h1 className="text-center text-2xl font-black  text-white uppercase">
            Gerez vos réclamations
          </h1>
    
             <p className="text-yellow-200 font-bold underline underline-offset-2 ">
            Besoin d'assistance ? <span>Nous sommes à votre service</span>
            </p>
         
         
        </section>
      </div>
       <div className="flex-grow">
        <div className="flex justify-center p-4">
          <div className="w-full max-w-3xl shadow-xl border border-black rounded-lg p-2">
           <ContactUs />
          </div>
        </div>
      </div>

      <FooterComponent className="flex-shrink-0" />
    </div>
  );
};

export default ContactPage;
